
import { Calendar } from "@/models/calendar";
import { UserConfigService } from "@/services/user-config-service";
import { CalendarState } from "@/utils/calendar-state";
import Vue from "vue";
import AppCalendarListHeader from "./CalendarListHeader.vue";
import AppGoogleCalendarEditModal from "./GoogleCalendarEditModal.vue";
import AppGoogleCalendarListItem from "./GoogleCalendarListItem.vue";
import AppCalendarEditModal from "./LocalCalendarEditModal.vue";
import AppLocalCalendarListItem from "./LocalCalendarListItem.vue";
import { AuthService } from "../../services/auth-service";
import { MODULE } from "../../config/modules";
import AppTaskFolderListItem  from "./TaskFolderListItem.vue";
import { FolderUser } from "../../models/tasks/folder-user";
import { GoogleCalendarService } from "@/services/google-calendar-service";

export default Vue.extend({
	data() {
		return {
			calendarSettings: UserConfigService.getCalendarSettings(),
			toEditCalendar: null as null | Calendar,
			toEditGoogleCalendar: null as null | gapi.client.calendar.CalendarListEntry,
			GoogleCalendarService,
			editGoogleCalendarModal: false
		};
	},
	props: {
		state: {
			type: Object as () => CalendarState,
			required: true
		}
	},
	computed: {
		isDemo(): boolean {
			return AuthService.wfCompany.IsDemo;
		},
		googleLoggedIn():boolean {
			return this.GoogleCalendarService.isLoggedIn();
		},
		googleCalendars():gapi.client.calendar.CalendarListEntry[] {
			return this.state.googleCalendars;
		},
		calendars():Calendar[] {
			return this.state.calendars;
		},
		googleActive():gapi.client.calendar.CalendarListEntry[] {
			return this.state.selectedGoogleCalendars;
		},
		active():Calendar[] {
			return this.state.selectedCalendars;
		},
		showTaskFolders():boolean {
			return AuthService.hasModule(MODULE.TAKEN);
		},
		taskFolders():FolderUser[]{
			return this.state.taskFolders;
		},
		selectedTaskFolders():FolderUser[] {
			return this.state.selectedTaskFolders;
		},
		googleCalendarEmail():string{
			return this.GoogleCalendarService.getLoggedInUserEmail();
		}
	},
	watch: {
		calendars: {
			immediate: true,
			handler() {
				this.active.splice(0);
				let list:Calendar[] = [];
				for (let cal of this.calendars) {
					let index = this.calendarSettings.OpenedCalendarIDs.findIndex(id => id == cal.ID);
					if (index != -1) {
						list.push(cal);
					}
				}
				this.active.push(...list);
			}
		},
		googleCalendars: {
			immediate: true,
			handler() {
				this.googleActive.splice(0, this.googleActive.length);
				for (let id of this.calendarSettings.OpenedGoogleCalendarIDs) {
					let cal = this.googleCalendars.find(c => c.id == id);
					if (cal) {
						this.googleActive.push(cal);
					}
				}
			}
		},
		taskFolders: {
			immediate: true,
			handler(){
				this.selectedTaskFolders.splice(0, this.selectedTaskFolders.length);
				for (let id of this.calendarSettings.OpenedTaskFolderIDs){
					let cal = this.taskFolders.find(f=>f.ID == id);
					if (cal){
						this.selectedTaskFolders.push(cal);
					}
				}
			}
		},
		googleLoggedIn(){
			this.fetchCals();
		}
	},
	methods: {
		newCalendar() {
			this.toEditCalendar = new Calendar();
		},
		newGoogleCalendar(){
			this.toEditGoogleCalendar = GoogleCalendarService.createNewCalendarListObject();
		},
		async calendarSaved(calendar:Calendar) {
			let index = this.calendars.findIndex((c) => c.ID == calendar.ID);
			if (index != -1) {
				this.$set(this.calendars, index, calendar);
				let activeIndex = this.active.findIndex((c) => c.ID == calendar.ID);
				if  (activeIndex != -1) {
					this.active[activeIndex] = calendar;
				}
			} else {
				this.calendars.push(calendar);
				this.loadCalendar(calendar);
				this.saveSettings();
			}
		},
		calendarDeleted(cal:Calendar, i:number) {
			this.calendars.splice(i, 1);
			let activeCalI = this.active.findIndex(c => c.ID == cal.ID);
			if (activeCalI != -1) {
				this.active.splice(activeCalI, 1);
				this.saveSettings();
			}
		},
		loadCalendar(item:Calendar) {
			let active = [...this.active];
			let i = active.findIndex(i => i.ID == item.ID);
			if (i != -1) {
				active.splice(i, 1);
			} else {
				active.push(item);
			}
			// Preserve order
			let list:Calendar[] = [];
			for (let cal of this.calendars) {
				let index = active.findIndex(c => c.ID == cal.ID);
				if (index != -1) {
					list.push(cal);
				}
			}
			this.active.splice(0);
			this.active.push(...list);
			this.saveSettings();
		},
		isCalendarActive(item:Calendar):boolean {
			return this.active.find(i => i.ID == item.ID) != null;
		},
		isTaskFolderActive(item:FolderUser):boolean{
			return this.selectedTaskFolders.find(t=>t.FolderID == item.FolderID) != null;
		},

		isGoogleCalendarActive(item:gapi.client.calendar.CalendarListEntry):boolean {
			return this.googleActive.find(i => i.id == item.id) != null;
		},
		loadGoogleCalendar(key:gapi.client.calendar.CalendarListEntry) {
			if (this.isGoogleCalendarActive(key)) {
				let i = this.googleActive.indexOf(key);
				this.googleActive.splice(i, 1);
			} else {
				this.googleActive.push(key);
			}
			this.saveSettings();
		},
		async googleCalendarDeleted(calendar:gapi.client.calendar.CalendarListEntry) {
			let index = this.googleCalendars.indexOf(calendar);
			if (index != -1) {
				this.googleCalendars.splice(index, 1);
			}

			index = this.googleCalendars.indexOf(calendar);
			if (index != -1) {
				this.googleCalendars.splice(index, 1);
			}
		},
		async googleCalendarSaved(calendar:gapi.client.calendar.CalendarListEntry) {
			let index = this.googleCalendars.findIndex(c => c.id == calendar.id);
			if (index != -1) {
				this.googleCalendars[index] = calendar;
				let activeIndex = this.googleActive.findIndex(c => c.id == calendar.id);
				if (activeIndex != -1) {
					this.googleActive[activeIndex] = calendar;
				}
			} else {
				this.googleCalendars.push(calendar);
				this.googleActive.push(calendar);
				this.saveSettings();
			}
		},
		loadTaskFolder(item:FolderUser){
			let i =this.selectedTaskFolders.findIndex(i=>i.FolderID == item.FolderID);
			if (i != -1){
				this.selectedTaskFolders.splice(i,1);
			}else{
				this.selectedTaskFolders.push(item);
			}
			this.saveSettings();
		},
		editCalendar(item:Calendar){
			this.toEditCalendar = new Calendar(item.getJSON());
		},
		async saveSettings() {
			this.calendarSettings.OpenedCalendarIDs = this.active.map(c => c.ID);
			this.calendarSettings.OpenedGoogleCalendarIDs = this.googleActive.map(g => g.id);
			this.calendarSettings.OpenedTaskFolderIDs = this.selectedTaskFolders.map(t=>t.ID);
			await UserConfigService.setCalendarSettings(this.calendarSettings);
		},
		refresh() {
			this.state.refreshView();
		},
		async fetchCals() {
			await this.state.fetchCals();
		},
		async googleLogin() {
			await GoogleCalendarService.login();
		},
	},
	async mounted(){
		this.GoogleCalendarService.getAccountInfo();
	},
	components: {
		AppCalendarListHeader,
		AppCalendarEditModal,
		AppLocalCalendarListItem,
		AppGoogleCalendarListItem,
		AppGoogleCalendarEditModal,
		AppTaskFolderListItem
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
